import React, { SetStateAction, Dispatch } from 'react';
import { Form, Row, Col, Dropdown } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

interface MultiselectBoxProps<T extends object> {
    id: string,
    name?: string,
    options: T[],
    selectedOptions: T[],
    setSelectedOptions: Dispatch<SetStateAction<T[]>>;
    map: keyof T,
    errors?: any
}

function MultiselectBox<T extends object>({
    id,
    name,
    options,
    selectedOptions,
    setSelectedOptions,
    map,
    errors
}: MultiselectBoxProps<T>) {

    const { t } = useTranslation();


    const selectOption = (option: T) => {
        setSelectedOptions(prev => {
            prev = prev ?? [];
            return prev.some(item => item[map] === option[map])
                ? prev.filter(item => item[map] !== option[map])
                : [...prev, option]
        }
        );
    };

    return (
        <Form.Group as={Row} controlId={id}>
            {name &&
                <Form.Label column xs={2} sm={3}>{name}:</Form.Label>
            }
            <Col xs={10} sm={9}>
                <Dropdown autoClose="outside">
                    <Dropdown.Toggle variant="light" id="dropdown-basic">
                        <span className="ms-1 me-1">
                            {selectedOptions.length > 0
                                ? selectedOptions.map(o => `${o[map]}`).join(", ")
                                : t<string>("Application.Controls.DefaultSelect")}
                        </span>
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                        {options.map(option => (
                            <div className="d-flex align-items-center ms-3">
                                <Form.Check.Input
                                    type="checkbox"
                                    checked={selectedOptions.some(o => o[map] === option[map])}
                                    onChange={() => selectOption(option)}
                                />
                                <Form.Check.Label className="ms-2">
                                    {option[map]}
                                </Form.Check.Label>
                            </div>
                        ))}
                    </Dropdown.Menu>
                </Dropdown>
                {errors && <p className="text-danger">{errors[id]}</p>}
            </Col>
        </Form.Group>
    );
}

export default MultiselectBox;